import { createContext } from 'react'

/**购物车context */
export const CartContext = createContext<{
  cartNumber: number
  setCartNumber: Function
}>({ cartNumber: 0, setCartNumber: () => {} })
